import { all, takeEvery, put, call } from 'redux-saga/effects'
import { REQUEST_LOGIN, REQUEST_SIGNUP, REQUEST_CHANGE_PASSWORD, ORIGIN_NOW } from './constants'
import { setAdmin, setIsAuthorized, setPasswordChanged, requestAuthFailure } from './actions'
import { message } from 'antd'
import AdminClient from '../../apiClient/AdminClient'
import history from '../../util/history'

const adminClient = new AdminClient()

function* onRequestLogin({ payload: { email, password, remember } }) {
    try {
        const { admin, jwt } = yield call(adminClient.login, { email, password })
        yield put(setAdmin({ admin, jwt }))
        yield put(setIsAuthorized(true))
        history.push('/')
    } catch (e) {
        yield put(requestAuthFailure())
        message.error('Failed to login.')
    }
}

function* onRequestSignup({ payload: { organization, email, password, origin } }) {
    try {
        const { admin, jwt } = yield call(adminClient.signup, {
            organization,
            email,
            password
        })
        yield put(setAdmin({ admin, jwt }))
        yield put(setIsAuthorized(true))
        if (origin === ORIGIN_NOW) {
            history.push('/now/start')
        } else {
            history.push('/')
        }
    } catch (e) {
        yield put(requestAuthFailure())
        message.error('Failed to signup, invalid informations.')
    }
}

function* onRequestChangePassword({ payload: { oldPass, newPass } }) {
    try {
        yield call(adminClient.changePass, { oldPass, newPass })

        yield put(setPasswordChanged())
        message.success('Password changed !')
    } catch (e) {
        message.error('Failed to change Password')
        yield put(setPasswordChanged())
    }
}

export default function* appSagas() {
    yield all([
        takeEvery(REQUEST_LOGIN, onRequestLogin),
        takeEvery(REQUEST_SIGNUP, onRequestSignup),
        takeEvery(REQUEST_CHANGE_PASSWORD, onRequestChangePassword)
    ])
}
